import { faArtstation } from '@fortawesome/free-brands-svg-icons'
import { faCalendar, faCalendarCheck, faTypewriter } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Form, ListItem, Text } from '@domain-group/suit-theme'

import { PublicationEditionDeadline } from '@hooks/usePublicationEditionDeadlines'
import type { FilterOptions } from '@hooks/usePublicationEditionDeadlines'

import useSelector from '@hooks/useSelector'

const deadlineIcon = (deadline: PublicationEditionDeadline) => {
  const { title } = deadline

  if (title === 'Editorial') return faTypewriter
  if (title === 'Artwork') return faArtstation
  if (title === 'OFI') return faCalendarCheck
  return faCalendar
}

interface DeadlineListItemProps {
  deadline: PublicationEditionDeadline,
  pageFilters: FilterOptions,
  updateFilters: (obj: {
    publication_id: number,
    publication_edition_id: number,
  }) => void,
}

const DeadlineListItem = (props: DeadlineListItemProps) => {
  const { deadline, pageFilters, updateFilters } = props

  const {
    // @ts-expect-error TS2339
    deadlineDate, publicationId, publicationEditionId, relativeDate,
  } = deadline

  const { publications } = useSelector(reduxState => reduxState.entities)
  const publication = publications[publicationId]

  const { title } = publication

  // @ts-expect-error TS2339
  const longFormatTime = deadlineDate.toFormat('h:mm a')

  return (
    <ListItem
      boxProps={{
        fontSize: 'xsmall', borderBottom: '1px solid', paddingY: 'large', as: 'a',
      }}
      onClick={() => updateFilters({
        ...pageFilters,
        publication_id: publicationId,
        publication_edition_id: publicationEditionId,
      })}
    >
      <Form.Field
        label={title}
        labelProps={{ style: { alignItems: 'center', padding: 'large', fontSize: 'xsmall' } }}
      >
        <Text fontSize="xsmall">
          <FontAwesomeIcon icon={deadlineIcon(deadline)} /> {relativeDate} at {longFormatTime}
        </Text>
      </Form.Field>
    </ListItem>
  )
}

export default DeadlineListItem
